
        import type { TemplateResult, TemplateRootPropsForTag } from 'Components/types';
type engineLookupDialogButtonRTRootProps = TemplateRootPropsForTag<'div'>;
import { createElement as _createElement } from 'preact';
import { map as _map } from 'Utils/array';
import _translate from 'Utils/translate';
export default function engineLookupDialogButtonRT(): TemplateResult<engineLookupDialogButtonRTRootProps> {
    return _createElement('div', { 'className': 'engine-garage garage-container cm_button' }, _createElement('div', { 'className': 'cm_changeButton' }, _createElement('span', { 'className': 'garage-icon' }, _createElement('svg', {
        'width': '24',
        'height': '24',
        'viewBox': '0 0 24 24',
        'fill': 'none',
        'xmlns': 'http://www.w3.org/2000/svg'
    }, _createElement('g', { 'clipPath': 'url(#clip0_1886_1901)' }, _createElement('path', {
        'd': 'M23.521 10.6113C23.3936 10.0233 22.938 9.63011 22.3794 9.63011H20.6937C20.0525 9.63011 19.5319 10.1515 19.5319 10.7919V11.774H19.1581V10.0326C19.1581 9.39218 18.6367 8.87076 17.9963 8.87076H15.9495V7.56891C15.9495 6.92853 15.4281 6.40712 14.7877 6.40712H10.8129V5.60306H14.381C14.824 5.60306 15.1825 5.24448 15.1825 4.80153C15.1825 4.35858 14.824 4 14.381 4H5.64182C5.19887 4 4.84029 4.35858 4.84029 4.80153C4.84029 5.24448 5.19887 5.60306 5.64182 5.60306H9.20989V6.40712H5.97678C5.3364 6.40712 4.81498 6.92853 4.81498 7.56891V7.95449H3.38826C2.74788 7.95449 2.22646 8.4759 2.22646 9.11628V12.5055H1.5979V8.93742C1.5979 8.49447 1.23932 8.13589 0.796369 8.13589C0.353419 8.13589 -0.00769043 8.49447 -0.00769043 8.93742V17.6766C-0.00769043 18.1196 0.350888 18.4781 0.793838 18.4781C1.23679 18.4781 1.59537 18.1196 1.59537 17.6766V14.1085H2.22393V17.4311C2.22393 18.0715 2.74535 18.5929 3.38573 18.5929H6.92427L10.4577 21H18.0233C18.6637 21 19.1851 20.4786 19.1851 19.8382V17.2176H19.6449V18.3482C19.6449 18.9886 20.1664 19.51 20.8067 19.51H22.3777C22.576 19.51 23.2417 19.4433 23.5049 18.5819L23.5108 18.5608C23.5311 18.4874 24.0061 16.7316 24.0061 14.3777C24.0061 12.6 23.5733 10.8282 23.5184 10.6122L23.521 10.6113ZM22.0217 17.9069H21.248V15.6146H17.5821V19.3969H10.9513L7.41784 16.9898H3.82615V9.55755H6.41466V8.01017H14.3439V10.4747H17.5534V13.3787H21.1333V11.234H22.0192C22.1381 11.7655 22.4039 13.0927 22.4039 14.3768C22.4039 16.0381 22.139 17.3881 22.0208 17.9069H22.0217Z',
        'fill': 'url(#paint0_linear_1886_1901)'
    }), _createElement('path', {
        'd': 'M5.07983 14.9621H6.38748V14.5935H5.53159V13.9962H6.29072V13.6373H5.53159V13.072H6.38748V12.7034H5.07983V14.9621Z',
        'fill': 'url(#paint1_linear_1886_1901)'
    }), _createElement('path', {
        'd': 'M8.2755 14.2546L7.2515 12.7034H6.79871V14.9621H7.2515V13.4146L8.2755 14.9621H8.72829V12.7034H8.2755V14.2546Z',
        'fill': 'url(#paint2_linear_1886_1901)'
    }), _createElement('path', {
        'd': 'M10.0985 14.0542H10.8738C10.8395 14.2181 10.7673 14.3454 10.6571 14.437C10.5469 14.5286 10.4061 14.5741 10.2341 14.5741C10.0941 14.5741 9.97119 14.5443 9.86544 14.4839C9.75969 14.4236 9.67777 14.3372 9.61819 14.2255C9.55861 14.1138 9.52957 13.982 9.52957 13.8316C9.52957 13.6811 9.55861 13.556 9.6167 13.4436C9.67479 13.3311 9.75596 13.2455 9.85874 13.1851C9.96225 13.1248 10.0807 13.095 10.214 13.095C10.3346 13.095 10.4404 13.1196 10.5305 13.1695C10.6206 13.2194 10.6921 13.2909 10.7435 13.3862H11.264C11.1925 13.1621 11.0637 12.9885 10.876 12.8642C10.6884 12.7405 10.4679 12.678 10.2132 12.678C9.998 12.678 9.80214 12.7271 9.62638 12.8247C9.45062 12.923 9.31285 13.0593 9.21306 13.235C9.11326 13.4108 9.06262 13.6096 9.06262 13.8308C9.06262 14.052 9.11252 14.2508 9.21306 14.4251C9.3136 14.5994 9.45137 14.7357 9.62638 14.834C9.80214 14.9323 9.99874 14.9807 10.2162 14.9807C10.4098 14.9807 10.5848 14.9405 10.7412 14.8593C10.8976 14.7789 11.025 14.6716 11.124 14.5376C11.2231 14.4043 11.2879 14.2583 11.3177 14.1012V13.7072H10.0963V14.0527L10.0985 14.0542Z',
        'fill': 'url(#paint3_linear_1886_1901)'
    }), _createElement('path', {
        'd': 'M12.1075 12.7061H11.6558V14.9618H12.1075V12.7061Z',
        'fill': 'url(#paint4_linear_1886_1901)'
    }), _createElement('path', {
        'd': 'M14.0306 14.2546L13.0066 12.7034H12.5538V14.9621H13.0066V13.4146L14.0306 14.9621H14.4834V12.7034H14.0306V14.2546Z',
        'fill': 'url(#paint5_linear_1886_1901)'
    }), _createElement('path', {
        'd': 'M14.9288 14.9621H16.2372V14.5935H15.3813V13.9962H16.1405V13.6373H15.3813V13.072H16.2372V12.7034H14.9288V14.9621Z',
        'fill': 'url(#paint6_linear_1886_1901)'
    })), _createElement('defs', {}, _createElement('linearGradient', {
        'id': 'paint0_linear_1886_1901',
        'x1': '11.9992',
        'y1': '4',
        'x2': '11.9992',
        'y2': '21',
        'gradientUnits': 'userSpaceOnUse'
    }, _createElement('stop', { 'stopColor': 'white' }), _createElement('stop', {
        'offset': '1',
        'stopColor': '#27AAE1'
    })), _createElement('linearGradient', {
        'id': 'paint1_linear_1886_1901',
        'x1': '5.73366',
        'y1': '12.7034',
        'x2': '5.73366',
        'y2': '14.9621',
        'gradientUnits': 'userSpaceOnUse'
    }, _createElement('stop', { 'stopColor': 'white' }), _createElement('stop', {
        'offset': '1',
        'stopColor': '#27AAE1'
    })), _createElement('linearGradient', {
        'id': 'paint2_linear_1886_1901',
        'x1': '7.7635',
        'y1': '12.7034',
        'x2': '7.7635',
        'y2': '14.9621',
        'gradientUnits': 'userSpaceOnUse'
    }, _createElement('stop', { 'stopColor': 'white' }), _createElement('stop', {
        'offset': '1',
        'stopColor': '#27AAE1'
    })), _createElement('linearGradient', {
        'id': 'paint3_linear_1886_1901',
        'x1': '10.1901',
        'y1': '12.678',
        'x2': '10.1901',
        'y2': '14.9807',
        'gradientUnits': 'userSpaceOnUse'
    }, _createElement('stop', { 'stopColor': 'white' }), _createElement('stop', {
        'offset': '1',
        'stopColor': '#27AAE1'
    })), _createElement('linearGradient', {
        'id': 'paint4_linear_1886_1901',
        'x1': '11.8816',
        'y1': '12.7061',
        'x2': '11.8816',
        'y2': '14.9618',
        'gradientUnits': 'userSpaceOnUse'
    }, _createElement('stop', { 'stopColor': 'white' }), _createElement('stop', {
        'offset': '1',
        'stopColor': '#27AAE1'
    })), _createElement('linearGradient', {
        'id': 'paint5_linear_1886_1901',
        'x1': '13.5186',
        'y1': '12.7034',
        'x2': '13.5186',
        'y2': '14.9621',
        'gradientUnits': 'userSpaceOnUse'
    }, _createElement('stop', { 'stopColor': 'white' }), _createElement('stop', {
        'offset': '1',
        'stopColor': '#27AAE1'
    })), _createElement('linearGradient', {
        'id': 'paint6_linear_1886_1901',
        'x1': '15.583',
        'y1': '12.7034',
        'x2': '15.583',
        'y2': '14.9621',
        'gradientUnits': 'userSpaceOnUse'
    }, _createElement('stop', { 'stopColor': 'white' }), _createElement('stop', {
        'offset': '1',
        'stopColor': '#27AAE1'
    })), _createElement('clipPath', { 'id': 'clip0_1886_1901' }, _createElement('rect', {
        'width': '24.0155',
        'height': '17',
        'fill': 'white',
        'transform': 'translate(-0.00769043 4)'
    }))))), _createElement('div', { 'className': 'cmTemplate_active cm_engine-garage-title' }, '\n      ', window.Convermax.getEngineString() || _translate(`engine_button_title`), '\n    ')));
}
        export const componentNames = []